export default {
  getProduct: (state) => state.product,
  specials: (state) => state.products.filter((product) => product.salePrice !== null),
};
